import { Component, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, formatDateTimeToLocal } from '@devwareapps/devware-cap';
import { ConfigService } from '../../../../../environments/environment';
import { TechTimerQueryEntity } from '../../meta-data/extensions/tech-timer-query-entity.model';
import { TechTimersListQueryEntity, TimerEntity, TimersMetaDataItemNames } from '../../meta-data/timers-meta-data.service';
import { TimerCardBaseComponent } from '../base/timer-card-base.component';
import { TimerCardConfigComponent } from '../timer-card-config/timer-card-config.component';


@DwComponent({
  name: 'Tech Timer Card',
  key: 'tecjTimerCard',
  componentType: DwComponentType.card,
  isGlobal: false,
  parentItemName: TimersMetaDataItemNames.Timer,
  configComponent: TimerCardConfigComponent
})
@Component({
  selector: 'app-tech-timer-card',
  templateUrl: './tech-timer-card.component.html',
  styleUrls: ['../../styles/timer-cards.scss', './tech-timer-card.component.scss']
})
export class TechTimerCardComponent extends TimerCardBaseComponent<TechTimersListQueryEntity> {
  
  
  defaultImageUrl: string = '/assets/img/user-avatar-original.png';
  employeeImageUrl: string = '/assets/img/user-avatar-original.png';

  cityState: string;
  trustCalendarUrl: string;
  employeeLaborMetrics: string;
  notes: string;

  countUp(): boolean {
    return true;
  }

  getReferenceDate(timer: TechTimersListQueryEntity): string {
    return timer?.StartDateTime;
  }
 
  setupCardData(techTimer: TechTimersListQueryEntity) {
    this.notes = techTimer.Notes;
    this.titleDisplay = techTimer.RoEthosUserNamePreferedLast || 'No Resource Assigned';

    if (techTimer.ResourceCity && techTimer.ResourceStateProvinceShortName) {
      this.cityState = `${techTimer.ResourceCity}, ${techTimer.ResourceStateProvinceShortName}`;
    }
    
    if (this.data.StartDateTime) {
      this.dateDisplay = `Available since ${formatDateTimeToLocal(this.data.StartDateTime, true, true)}`;
    }

    this.data.TechEthosRoUserSkillListTimerSkillList
    this.employeeLaborMetrics = `Current: ${techTimer.EthosLaborMetricsHoursCurrentWeek}hrs  Last:${techTimer.EthosLaborMetricsHoursLastWeek}hrs`;
    this.employeeImageUrl = ConfigService.config.apiRoot + "/trust/ProfilePic?userId=" + techTimer.TechEthos_UserId;
    this.trustCalendarUrl = `${ConfigService.config.trustBaseUrl}/ResourceMgmt/Calendar.aspx?userId=${techTimer.TechEthos_UserId}`;
  }

  timeLeftAdjustment() {
    return 0;
  }

  reset() {
    this.data.StartDateTime = this.timerUtilService.addDateTimeOffset(0);

    super.reset();
  }




}
